<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25"
    >
      <div class="d-sm-flex align-items-center">
        <button
          class="default-outline-btn position-relative transition fw-medium text-black pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-30 pe-md-30 rounded-1 bg-transparent fs-md-15 fs-lg-16 d-inline-block mb-10 mb-lg-0"
          type="button"
          @click="newClientExport()"
        >
          Export
          <i class="flaticon-file-1 position-relative ms-5 top-2 fs-15"></i>
        </button>
      </div>
      <div class="d-flex align-items-center">
        <input
          type="text"
          class="form-control shadow-none text-black rounded-0"
          placeholder="Search "
        />
      </div>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <vue-good-table :columns="headers" :rows="rows">
        <!-- Empty state -->
        <template #emptystate>
          <center>Aucune entrées correspondantes trouvées</center>
        </template>

        <!-- Custom row -->
        <template #table-row="props">
          <span v-if="props.column.field == 'created_at'">
            {{ getDate(props.row.created_at) }}
          </span>
         
          <span v-else-if="props.column.field === 'statut'">
            <div v-if="props.row.statut==0" class="badge text-bg-warning fs-13 me-5 mt-10">Nouvelle Demande</div>
            <div v-if="props.row.statut==1" class="badge text-bg-success fs-13 me-5 mt-10">Demande traitée</div>
            <div v-if="props.row.statut==2" class="badge text-bg-danger fs-13 me-5 mt-10"> Demande refusée</div>
            
        </span>

        
         <span v-else-if="props.column.field === 'customer_name'">
             <a target='_blank' href="">{{props.row.customer_name}}</a>
        </span>

        <tamplate v-else-if="props.column.field === 'note'">
          <p >
                {{ props.row.note }}
            </p>
        </tamplate>

        <span v-else-if="props.column.field === 'statut_note'">
          <p>{{props.row.statut_note}}</p>
        </span>
        
        <template v-else-if="props.column.field === 'new_rib'">
            <div class="text-nowrap">
                <span class="text-danger">{{props.row.old_rib}}</span><br/>
                <h6 class="text-success">{{props.row.new_rib}}</h6>
            </div>
          </template>

          <span v-else-if="props.column.field == 'action'">
            <!-- <div class="dropdown">
              <button
                class="dropdown-toggle card-dot-btn lh-1 position-relative top-4 bg-transparent border-0 shadow-none p-0 transition"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i class="flaticon-dots"></i>
              </button>
              <ul class="dropdown-menu">
                <li>
                  <a
                    class="dropdown-item d-flex align-items-center"
                    href="javascript:void(0);"
                  >
                    <i
                      class="flaticon-pen lh-1 me-8 position-relative top-1"
                    ></i>
                    Modifier
                  </a>
                </li>
                <li>
                  <a
                    class="dropdown-item d-flex align-items-center"
                    href="javascript:void(0);"
                    @click="cancelRequest(props.row)"
                  >
                    <i
                      class="ph ph-trash lh-1 me-8 position-relative top-1"
                    ></i>
                    Supprimer
                  </a>
                </li>
              </ul>
            </div> -->
          </span>

          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>
      </vue-good-table>
      <PaginatorContent
        :pagination="users"
        :offset="9"
        @paginate="fetchData"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { useAppToast } from "@/composables/useAppToast";
import api from "@/utils/axios";
import moment from "moment";
import Swal from "sweetalert2";
import { defineComponent, onMounted, reactive, ref } from "vue";
import { useAuthStore } from "@/stores/auth";
import { Modal } from "bootstrap";
export default {
  name: "RibRequests",
  setup: () => {
    const { showToast } = useAppToast();

    const auth = useAuthStore();
    const user = auth.user;

    const updateImgInput = ref<HTMLInputElement | null>(null);
    const imagepreview = ref<string | null>(null);
    const isEditing = ref(false);
    const headers = [
      
        {
          label: 'Client',
          field: 'customer_name',
        },
        {
          label: 'Date d\'ajout',
          field: 'created_at',
        },
        {
          label: 'Raison',
          field: 'raison',
        },
        {
          label: 'RIB',
          field: 'new_rib',
        },
        {
          label: 'Banque',
          field: 'bank_name',
        },
        {
          label: 'Statut',
          field: 'statut',
        },
        {
          label: 'Commentaire',
          field: 'statut_note',
        },
        {
          label: 'Actions',
          field: 'action',
        },
    ];

    const rows = ref([]);
    const loading = ref(false);

    const users = reactive({
      searchTearm: "",
        searchCustomer:"",
        searchBank:"",
        searchStatut:"",
        searchDate:"",
        total: 0,
        per_page: 10,
        from: 1,
        to: 0,
        current_page: 1,
    });

    // Fetch data from API
    const fetchData = async (page = 1) => {
      loading.value = true;
      users.current_page = page;

      try {
        const res = await api.get(`/api/auth/RibRequests`, {
          params: {
            searchTearm: users.searchTearm,
            searchCustomer: users.searchCustomer,
            searchBank: users.searchBank,
            searchStatut: users.searchStatut,
            searchDate: users.searchDate,
            page: users.current_page,
            per_page: users.per_page,
          },
        });

        rows.value = res.data.users.data;
        Object.assign(users, res.data.users);
      } catch (err) {
        console.error(err);
      } finally {
        loading.value = false;
      }
    };

    onMounted(async () => {
      fetchData();
    });

    function getDate(value: any) {
      return moment.utc(String(value)).format("YYYY-MM-DD HH:mm");
    }

    async function destroyUser(row) {
      let data = new FormData();
      data.append("user_id", user?.id);
      data.append("customer_id", row.customer_id);

      Swal.fire({
        text: "Vous voulez supprimer cet utilisateur ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Oui, supprimer!",
      }).then(async (result) => {
        // make callback async
        if (result.isConfirmed) {
          // use isConfirmed instead of value
          try {
            const res = await api.post(
              `/api/auth/destroyStaff/${row.id}`,
              data
            );
            if (res.data.msg === "success") {
              fetchData();
              showToast("Utilisateur a bien été supprimé", "success");
            } else {
              showToast("Erreur lors de la suppression", "error");
            }
          } catch (error) {
            console.error(error);
            showToast("Erreur serveur", "error");
          }
        }
      });
    }

    function oldPhone(val) {
      if (val && val !== "" && val != null) {
        let phone = "";
        if (val.substring(0, 4) === "+212" && val.length === 13) {
          return `0${val.slice(4)}`;
        }
        if (val.substring(0, 3) === "212" && val.length === 12) {
          phone = `0${val.slice(2)}`;
          return phone;
        }
        if (val.substring(0, 1) === "0" && val.length === 10) {
          return val;
        }
        if (
          val.substring(0, 1) === "6" ||
          (val.substring(0, 1) === "7" && val.length === 9)
        ) {
          // phone = "+212" + val;
          return val;
        }
        if (val.substring(0, 5) === "00212" && val.length === 14) {
          return `0${val.substring(0, 5)}`;
        }
      } else {
        return val;
      }
    }

    function substrPhone(val) {
      if (val && val != "" && val != null) {
        let phone = "";
        if (val.substring(0, 4) == "+212" && val.length == 13) {
          return val;
        }
        if (val.substring(0, 3) == "212" && val.length == 12) {
          phone = `+${val}`;
          return phone;
        }
        if (val.substring(0, 1) == "0" && val.length == 10) {
          phone = `212${val}`;
          return phone;
        }
        if (
          val.substring(0, 1) == "6" ||
          (val.substring(0, 1) == "7" && val.length == 9)
        ) {
          phone = `212${val}`;
          return phone;
        }
      } else {
        return val;
      }

      // return val.substring(0,x);
    }

    async function cancelRequest(row) {
      let data = new FormData();
      data.append("request_id", row.id);
      data.append("user_id", user?.id);

      Swal.fire({
        text: "Vous voulez archiver cette demande ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Oui",
      }).then(async (result) => {
        // <-- make this async
        if (result.isConfirmed) {
          // use isConfirmed instead of value
          try {
            const res = await api.post(`/api/auth/archived_cust_request`, data);
            if (res.data.msg === "success") {
              showToast("Demande est bien archivée", "success");
            } else {
              showToast("Une erreur est survenue", "error");
            }
          } catch (error) {
            console.error(error);
            showToast("Erreur lors de l'archivage", "error");
          }
        }
      });
    }
    async function newClientExport(){
      await api(`/api/auth/NewClientExport`,{responseType: 'arraybuffer'}).then(res => { 
        let fileURL = window.URL.createObjectURL(new Blob([res.data],{
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        }));
        let fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.download = 'NewClientExport.xlsx';
        fileLink.click();
       
      })
    }

    return {
      headers,
      rows,
      users,
      loading,
      fetchData,
      getDate,
      updateImgInput,
      imagepreview,
      destroyUser,
      oldPhone,
      cancelRequest,
      substrPhone,
      newClientExport
    };
  },
};
</script>